module.exports = __webpack_public_path__ + "media/application/images/svgs/carrot-arrow-down-cea5e5824dfb1ca7f83c8c5d1eb9bd05.svg";